/**
 * Curate continue — leave confirm + home corner chip.
 * Prompts when 1+ picks are saved and not yet added to bag
 * (including a full set like 6/6 that hasn't been checked out).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'hummara_curate_draft';
  var CHIP_HIDE_KEY = 'hummara_curate_chip_hide';
  var allowLeaveOnce = false;

  function storageGet(key) {
    try {
      return localStorage.getItem(key) || sessionStorage.getItem(key);
    } catch (e) {
      try {
        return sessionStorage.getItem(key);
      } catch (err) {
        return null;
      }
    }
  }

  function storageSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  function storageRemove(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {}
    try {
      sessionStorage.removeItem(key);
    } catch (e) {}
  }

  function readDraft() {
    try {
      var raw = storageGet(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.path || !data.maxItems) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function writeDraft(data) {
    if (!data) {
      storageRemove(STORAGE_KEY);
      return;
    }
    try {
      storageSet(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function clearDraft() {
    writeDraft(null);
    storageRemove(CHIP_HIDE_KEY);
    hideChip();
    paintHeroCard();
  }

  /** True while picks exist and haven't been added to bag yet. */
  function shouldPrompt(draft) {
    if (!draft) return false;
    var count = parseInt(draft.count, 10) || 0;
    var max = parseInt(draft.maxItems, 10) || 0;
    return count >= 1 && max > 0 && count <= max;
  }

  function isReady(draft) {
    if (!draft) return false;
    return parseInt(draft.count, 10) === parseInt(draft.maxItems, 10);
  }

  function isCuratePath(pathname) {
    var p = pathname || '';
    return /^\/pages\/pick-any-\d+\/?$/.test(p) || /^\/pages\/party-favours\/?$/.test(p);
  }

  function samePath(a, b) {
    var na = (a || '').replace(/\/$/, '') || '/';
    var nb = (b || '').replace(/\/$/, '') || '/';
    return na === nb;
  }

  window.HummaraCurate = {
    STORAGE_KEY: STORAGE_KEY,
    read: readDraft,
    write: writeDraft,
    clear: clearDraft,
    shouldPrompt: shouldPrompt,
    isIncomplete: shouldPrompt, // alias used by bundle-builder restore
    isReady: isReady,
    isCuratePath: isCuratePath,
    persistFromBuilder: function (payload) {
      if (!payload) return;
      var count = parseInt(payload.count, 10) || 0;
      var max = parseInt(payload.maxItems, 10) || 0;
      if (count < 1 || max < 1) {
        clearDraft();
        return;
      }
      writeDraft({
        path: payload.path || window.location.pathname,
        maxItems: max,
        count: Math.min(count, max),
        ready: count >= max,
        order: payload.order || [],
        picks: payload.picks || [],
        updatedAt: Date.now(),
      });
      try {
        storageRemove(CHIP_HIDE_KEY);
      } catch (e) {}
      paintHeroCard();
    },
  };

  /* ── Leave modal ── */
  var modalEl = null;

  function ensureModal() {
    if (modalEl) return modalEl;
    modalEl = document.createElement('div');
    modalEl.className = 'hc-leave';
    modalEl.hidden = true;
    modalEl.innerHTML =
      '<div class="hc-leave__backdrop" data-hc-leave-stay></div>' +
      '<div class="hc-leave__sheet" role="dialog" aria-modal="true" aria-labelledby="hc-leave-title">' +
      '<p class="hc-leave__eyebrow" data-hc-leave-eyebrow>Almost there</p>' +
      '<h3 class="hc-leave__title" id="hc-leave-title" data-hc-leave-title>Continue with your curated set?</h3>' +
      '<p class="hc-leave__text" data-hc-leave-text></p>' +
      '<div class="hc-leave__actions">' +
      '<button type="button" class="hc-leave__btn hc-leave__btn--ghost" data-hc-leave-go>Leave</button>' +
      '<button type="button" class="hc-leave__btn hc-leave__btn--primary" data-hc-leave-stay>Keep curating</button>' +
      '<button type="button" class="hc-leave__btn hc-leave__btn--primary" data-hc-leave-add hidden>Add to bag</button>' +
      '</div></div>';
    document.body.appendChild(modalEl);

    var pendingHref = null;

    modalEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-hc-leave-stay]')) {
        pendingHref = null;
        closeModal();
        return;
      }
      if (e.target.closest('[data-hc-leave-add]')) {
        pendingHref = null;
        closeModal();
        addReadySetToBag();
        return;
      }
      var go = e.target.closest('[data-hc-leave-go]');
      if (go && pendingHref) {
        allowLeaveOnce = true;
        closeModal();
        window.location.href = pendingHref;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modalEl && !modalEl.hidden) {
        pendingHref = null;
        closeModal();
      }
    });

    modalEl._setPending = function (href) {
      pendingHref = href;
    };
    return modalEl;
  }

  function addReadySetToBag() {
    if (typeof window.HummaraCurateSubmitReady === 'function') {
      window.HummaraCurateSubmitReady();
      return;
    }
    var submit =
      document.querySelector('.bb__bar.is-complete [data-bb-submit]') ||
      document.querySelector('[data-bb-submit]:not([disabled])');
    if (submit) submit.click();
  }

  function openLeaveModal(href, draft) {
    var el = ensureModal();
    var ready = isReady(draft);
    var eyebrow = el.querySelector('[data-hc-leave-eyebrow]');
    var title = el.querySelector('[data-hc-leave-title]');
    var text = el.querySelector('[data-hc-leave-text]');
    var stayBtn = el.querySelector('[data-hc-leave-stay]');
    var addBtn = el.querySelector('[data-hc-leave-add]');
    if (eyebrow) eyebrow.textContent = ready ? 'Set ready' : 'Almost there';
    if (title) {
      title.textContent = ready
        ? 'Your set is ready — add it to bag?'
        : 'Continue with your curated set?';
    }
    if (text) {
      text.textContent = ready
        ? 'You picked all ' +
          draft.maxItems +
          '. Add them to your bag now, or leave and continue later from Home.'
        : 'You have ' +
          draft.count +
          ' of ' +
          draft.maxItems +
          ' picks saved. Stay and finish your set, or leave and continue later from Home.';
    }
    if (stayBtn) {
      stayBtn.hidden = !!ready;
      stayBtn.textContent = 'Keep curating';
    }
    if (addBtn) {
      addBtn.hidden = !ready;
      addBtn.textContent = 'Add to bag';
    }
    el._setPending(href);
    el.hidden = false;
    document.documentElement.classList.add('hc-leave-open');
  }

  function closeModal() {
    if (!modalEl) return;
    modalEl.hidden = true;
    document.documentElement.classList.remove('hc-leave-open');
  }

  function interceptLeaveClicks() {
    document.addEventListener(
      'click',
      function (e) {
        if (allowLeaveOnce) {
          allowLeaveOnce = false;
          return;
        }
        if (!isCuratePath(window.location.pathname)) return;
        var draft = readDraft();
        if (!shouldPrompt(draft)) return;
        if (e.defaultPrevented) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (e.button !== 0) return;

        var a = e.target.closest('a[href]');
        if (!a) return;
        if (a.hasAttribute('download')) return;
        if (a.getAttribute('target') === '_blank') return;
        if (a.closest('.hc-leave')) return;
        if (a.closest('[data-bundle-builder]')) {
          var hrefAttr = a.getAttribute('href') || '';
          if (hrefAttr.charAt(0) === '#') return;
        }

        var url;
        try {
          url = new URL(a.href, window.location.origin);
        } catch (err) {
          return;
        }
        if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
        if (url.origin !== window.location.origin) return;
        if (samePath(url.pathname, window.location.pathname)) return;

        e.preventDefault();
        e.stopPropagation();
        openLeaveModal(url.href, draft);
      },
      true
    );
  }

  /* ── Home / site corner chip ── */
  var chipEl = null;

  function chipHidden() {
    return storageGet(CHIP_HIDE_KEY) === '1';
  }

  function hideChip() {
    if (chipEl) {
      chipEl.classList.remove('is-visible');
      chipEl.hidden = true;
    }
  }

  function ensureChip() {
    if (chipEl) return chipEl;
    chipEl = document.createElement('div');
    chipEl.className = 'hc-chip';
    chipEl.hidden = true;
    chipEl.innerHTML =
      '<a class="hc-chip__link" data-hc-chip-go href="#">' +
      '<span class="hc-chip__pulse" aria-hidden="true"></span>' +
      '<span class="hc-chip__count" data-hc-chip-count></span>' +
      '<span class="hc-chip__copy">' +
      '<strong data-hc-chip-title>Continue curating</strong>' +
      '<span data-hc-chip-sub></span>' +
      '</span>' +
      '<span class="hc-chip__arrow" aria-hidden="true">→</span>' +
      '</a>' +
      '<button type="button" class="hc-chip__close" data-hc-chip-close aria-label="Dismiss">×</button>';
    document.body.appendChild(chipEl);

    chipEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-hc-chip-close]')) {
        e.preventDefault();
        try {
        storageSet(CHIP_HIDE_KEY, '1');
        } catch (err) {}
        hideChip();
        return;
      }
    });
    return chipEl;
  }

  function expandDraftSlots(draft) {
    var max = parseInt(draft.maxItems, 10) || 6;
    var slots = [];
    (draft.picks || []).forEach(function (pick) {
      var n = Math.max(1, parseInt(pick.qty, 10) || 1);
      var i;
      for (i = 0; i < n && slots.length < max; i++) slots.push(pick);
    });
    return slots;
  }

  function isHeroSixDraft(draft) {
    if (!shouldPrompt(draft)) return false;
    var max = parseInt(draft.maxItems, 10) || 0;
    var path = draft.path || '';
    return max === 6 || /pick-any-6/.test(path);
  }

  function resetHeroCard(root) {
    root.classList.remove('has-draft');
    root.querySelectorAll('[data-hcs-step]').forEach(function (step, i) {
      step.classList.remove('is-filled');
      step.classList.toggle('is-active', i === 0);
      step.textContent = String(i + 1);
    });
    var btn = root.querySelector('[data-hcs-btn]');
    if (btn) {
      btn.textContent = btn.getAttribute('data-hcs-btn-default') || 'Build my 6 →';
    }
  }

  function paintHeroCard() {
    var root = document.querySelector('.hcs');
    if (!root) return;
    var draft = readDraft();
    if (!isHeroSixDraft(draft)) {
      resetHeroCard(root);
      return;
    }

    root.classList.add('has-draft');
    var slots = expandDraftSlots(draft);
    root.querySelectorAll('[data-hcs-step]').forEach(function (step, i) {
      var pick = slots[i];
      step.classList.remove('is-active', 'is-filled');
      step.textContent = '';
      if (pick && pick.image) {
        step.classList.add('is-filled');
        var img = document.createElement('img');
        img.src = pick.image;
        img.alt = pick.title || '';
        step.appendChild(img);
      } else {
        step.textContent = String(i + 1);
      }
    });

    var btn = root.querySelector('[data-hcs-btn]');
    if (btn) {
      btn.href = draft.path || '/pages/pick-any-6';
      btn.textContent = 'Continue (' + draft.count + '/' + draft.maxItems + ') →';
    }
    var heroCta = root.querySelector('.hcs__cta');
    if (heroCta) heroCta.href = draft.path || heroCta.getAttribute('href');
  }

  function refreshChip() {
    paintHeroCard();
    var draft = readDraft();
    var heroShowing = document.querySelector('.hcs.has-draft');
    if (!shouldPrompt(draft) || chipHidden() || heroShowing) {
      hideChip();
      return;
    }
    // Don't show chip while already on that curate page
    if (samePath(window.location.pathname, draft.path)) {
      hideChip();
      return;
    }

    var el = ensureChip();
    var ready = isReady(draft);
    var link = el.querySelector('[data-hc-chip-go]');
    var count = el.querySelector('[data-hc-chip-count]');
    var title = el.querySelector('[data-hc-chip-title]');
    var sub = el.querySelector('[data-hc-chip-sub]');
    if (link) link.href = draft.path;
    if (count) count.textContent = draft.count + '/' + draft.maxItems;
    if (title) title.textContent = ready ? 'Add your set to bag' : 'Continue curating';
    if (sub) {
      sub.textContent = ready
        ? 'Your ' + draft.maxItems + '-piece set is ready'
        : 'Your ' + draft.maxItems + '-piece set is waiting';
    }
    el.hidden = false;
    requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });
  }

  function init() {
    interceptLeaveClicks();
    refreshChip();
    window.addEventListener('pageshow', refreshChip);
    document.addEventListener('hummara:curate-draft-changed', refreshChip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
